import React from 'react'
import About from '../public/about/About'
import MenuProvideradmin from './navProvideradmin/MenuProvideradmin'

function AboutExecutive() {
    return (
        <div>
            <MenuProvideradmin />
            <About disabledMenu />
        </div>
    )
}

export default AboutExecutive